export const AI_ACTING_FILTERS = [
  { id: "all", label: "全部" },
  { id: "joy", label: "喜" },
  { id: "anger", label: "怒" },
  { id: "sad", label: "哀" },
  { id: "happy", label: "乐" },
  { id: "restrained", label: "压抑类" },
  { id: "peak", label: "爆发/余波" },
];

export const AI_ACTING_LEVELS = [
  { level: 0, label: "潜伏", detail: "外表接近日常，只让眼神、呼吸或停顿泄露。" },
  { level: 1, label: "微弱", detail: "观众能感觉情绪出现，但角色还在试探。" },
  { level: 2, label: "明确", detail: "情绪已经可读，脸和身体开始配合。" },
  { level: 3, label: "强烈", detail: "情绪占据场面，动作、声音和节奏明显改变。" },
  { level: 4, label: "压抑", detail: "内部强、外部控制，裂缝比爆发更重要。" },
  { level: 5, label: "爆发", detail: "短时间满格释放，身体先于语言。" },
  { level: 6, label: "余波", detail: "爆发后下沉、空白、喘息、哭笑或麻木。" },
];

export const AI_ACTING_CURVES = [
  {
    title: "惊喜",
    path: ["空白", "确认", "笑开"],
    detail: "先不动，眼睛睁大，吸气停住；确认后嘴角慢慢打开，再靠近或说话。",
  },
  {
    title: "强忍悲",
    path: ["撑住", "裂缝", "收回"],
    detail: "眼眶亮，嘴角试图保持礼貌，下颌锁住，呼气很慢，台词越平越痛。",
  },
  {
    title: "冷怒到暴怒",
    path: ["静止", "低声", "爆点"],
    detail: "前半段少动、低声、直视；触发词出现后拍桌或逼近，但爆发必须短。",
  },
  {
    title: "喜极而泣",
    path: ["笑", "停住", "泪"],
    detail: "笑容还在，眼眶变湿，下巴轻颤，身体下沉，声音从亮变薄。",
  },
  {
    title: "忍笑到爆笑",
    path: ["压住", "漏气", "失控"],
    detail: "嘴唇抿住，眼睛躲开，鼻息漏出，肩膀微抖，最后笑声冲破台词。",
  },
  {
    title: "崩溃后麻木",
    path: ["痛哭", "喘", "空白"],
    detail: "哭声慢慢断掉，眼神失焦，手停在半空，声音变平，像自动完成动作。",
  },
];

export const AI_ACTING_PROMPT_TEMPLATES = [
  {
    title: "近景微表情",
    detail: "近景固定镜头，角色听到消息后先停住，眼神变化先于嘴角变化，呼吸轻微改变，面部动作控制在小幅度，背景不抢戏。",
  },
  {
    title: "中景身体表演",
    detail: "中景拍摄，角色的情绪通过重心、肩颈、手部动作和靠近/后退表现，脸部表情与身体方向一致。",
  },
  {
    title: "情绪转折",
    detail: "先出现触发点，再停顿半秒，然后眼神、呼吸、嘴角、身体依次改变，最后台词跟上。",
  },
];

export const AI_ACTING_CARDS = [
  {
    emotion: "喜",
    type: "joy",
    level: 0,
    name: "暗喜/期待未露",
    tags: ["subtle"],
    core: "好事可能发生，但角色还不敢确认。",
    eyes: "眼神短暂变亮，偷看目标，马上收回。",
    mouth: "嘴角几乎不动，可能轻轻抿住。",
    body: "重心微微向前，手指整理衣角或手机。",
    breath: "吸气轻，呼气短，像怕情绪漏出来。",
    shot: "特写或近景，不要大动作。",
    timeline: ["盯住信息，身体停半秒", "眼睛亮一下，嘴角被压住", "低头或移开视线，把喜悦藏回去"],
    prompt: "近景固定镜头，角色看到一个可能的好消息。0-1秒她盯着屏幕，眼神微微发亮；1-2秒嘴角想上扬但被抿住，下颌轻轻收紧；2-3秒她快速移开视线，假装平静，手指整理袖口。表演克制、真实、生活化。",
    avoid: "避免直接大笑、露齿笑、跳跃、卡通式兴奋。",
  },
  {
    emotion: "喜",
    type: "joy",
    level: 1,
    name: "微喜/被照亮",
    tags: ["subtle"],
    core: "小确认出现，角色开始允许自己相信。",
    eyes: "眼睛更聚焦，回看对方，眼角轻微柔化。",
    mouth: "嘴角上扬 10%-20%，脸颊轻抬。",
    body: "肩颈放松，胸口打开一点。",
    breath: "轻轻呼气，可能有鼻息笑。",
    shot: "近景最有效，保持动作干净。",
    timeline: ["先确认信息", "眼神回到对方脸上", "嘴角轻起，声音变亮"],
    prompt: "近景，角色听到确认性的好消息。她先愣住半秒，然后眼睛变亮，眉间放松，嘴角轻轻上扬但不露齿；肩膀放松，轻轻呼出一口气，用更亮的声音回应。整体是微弱但可读的开心。",
    avoid: "避免夸张点头、持续傻笑、眼睛没有变化。",
  },
  {
    emotion: "喜",
    type: "joy",
    level: 2,
    name: "欣喜/明确开心",
    tags: [],
    core: "愿望得到满足，角色愿意让别人看见。",
    eyes: "眼睛亮，视线稳定，寻找分享对象。",
    mouth: "笑容打开，脸颊抬起，可轻微露齿。",
    body: "身体向外打开，手势自然增多。",
    breath: "呼气带笑，语速变轻快。",
    shot: "中近景，保留表情和手部。",
    timeline: ["确认结果", "看向能分享的人", "笑容打开并靠近一点"],
    prompt: "中近景，角色终于确认好消息。0-1秒她盯着结果，眼睛明显发亮；1-2秒抬头看向朋友，笑容自然打开，脸颊抬起；2-4秒身体向前一步，语速轻快地说出一句短台词。开心明确但不过火。",
    avoid: "避免空笑、摇头太多、身体和眼睛没有分享对象。",
  },
  {
    emotion: "喜",
    type: "joy",
    level: 3,
    name: "大喜/兴奋",
    tags: [],
    core: "快乐冲出来，角色暂时难以完全管理。",
    eyes: "眼睛睁大，视线跳向见证者。",
    mouth: "笑容大开，下颌更自由。",
    body: "身体变轻，可能小跑、张开手臂或拥抱。",
    breath: "呼吸快，笑声打断句子。",
    shot: "中景，给身体一点活动空间。",
    timeline: ["先静止确认", "笑容突然打开", "身体冲向目标或拥抱"],
    prompt: "中景跟拍，角色得到等待已久的好消息。她先停住一瞬，随后眼睛睁大，笑容快速打开，呼吸变快；她向朋友小跑过去，手臂张开，笑声打断台词。动作兴奋但仍真实，不要卡通化。",
    avoid: "避免无缘由尖叫、动作乱飞、一直满格不回落。",
  },
  {
    emotion: "喜",
    type: "joy",
    level: 4,
    name: "强忍喜/喜中带防备",
    tags: ["restrained"],
    core: "好事发生，但场合不允许表现。",
    eyes: "眼神先亮，随后快速移开或低下。",
    mouth: "嘴角想上扬，被抿唇压住。",
    body: "转身、整理文件、假装忙。",
    breath: "吸气卡住，慢慢压下呼气。",
    shot: "特写，抓住泄露的一瞬。",
    timeline: ["听到好消息", "眼底发亮，嘴角抽动", "立刻低头装作平静"],
    prompt: "特写，角色在正式场合听到自己赢了。0-1秒眼睛突然亮一下；1-2秒嘴角要上扬但被她抿住，下颌轻轻锁住；2-4秒她低头整理文件，声音故意平静地说“知道了”。重点是强忍喜悦。",
    avoid: "避免完全面无表情、直接笑出来、把克制演成冷漠。",
  },
  {
    emotion: "喜",
    type: "joy",
    level: 5,
    name: "狂喜/失控释放",
    tags: ["peak"],
    core: "情绪超过礼貌，身体先行动。",
    eyes: "眼神大开，可能湿润，视线不稳定。",
    mouth: "大笑、哭笑，台词断裂。",
    body: "跳起、冲过去、抱住别人。",
    breath: "笑和喘混在一起。",
    shot: "中景或跟拍，给爆发方向。",
    timeline: ["结果出现", "身体先弹起", "冲向目标，笑到说不完整"],
    prompt: "中景手持跟拍，角色确认自己成功。0-1秒她愣住，眼睛睁大；1-3秒突然跳起，大笑，双手捂住嘴又放开；3-6秒冲向朋友拥抱，笑到台词断裂，呼吸急促。爆发短而有方向。",
    avoid: "避免长时间尖叫、无目标乱跑、表情卡通化。",
  },
  {
    emotion: "喜",
    type: "joy",
    level: 6,
    name: "喜极而泣/余波",
    tags: ["peak"],
    core: "快乐太大，过去的压力一起松开。",
    eyes: "眼神软化，眼眶湿，像终于确认现实。",
    mouth: "笑还在，但嘴角颤。",
    body: "身体下沉，坐下或抱住自己。",
    breath: "笑、抽气、长呼交替。",
    shot: "特写或静止近景，少动作更强。",
    timeline: ["笑容还在", "眼眶变湿，下巴轻颤", "身体坐下，声音变轻"],
    prompt: "特写静止镜头，角色大喜之后慢慢安静。她脸上还带着笑，但眼眶变湿，下巴轻轻发抖；她低头长长呼气，坐下，用很轻的声音说“我做到了”。情绪是喜悦后的释放，不是单纯悲伤。",
    avoid: "避免继续大喊大笑、直接切成痛哭、没有回落过程。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 0,
    name: "不悦/刺痛",
    tags: ["subtle"],
    core: "边界被碰到，角色还在判断是否反击。",
    eyes: "眼神变硬，停留更直，眨眼减少。",
    mouth: "嘴唇变薄，下颌轻微固定。",
    body: "手指停住，肩颈微紧。",
    breath: "鼻息变重，呼气短。",
    shot: "近景，利用停顿制造压迫。",
    timeline: ["听见冒犯", "动作停住", "眼神抬起并盯住对方"],
    prompt: "近景，角色听到一句冒犯的话。0-1秒她手上的动作停住；1-2秒眼神抬起，变硬，眨眼减少；2-3秒嘴唇压薄，下颌轻轻收紧，但还没有开口。怒意处于潜伏状态。",
    avoid: "避免立刻瞪眼、吼叫、夸张皱眉。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 1,
    name: "轻怒/警告",
    tags: ["subtle"],
    core: "角色明确感到被冒犯，但还留余地。",
    eyes: "目光直压对方，眼皮略收。",
    mouth: "嘴角下降，吐字前下颌准备。",
    body: "身体朝向对方，手势变少。",
    breath: "短促鼻呼。",
    shot: "近景或双人中近景。",
    timeline: ["抬眼", "停顿", "低声警告"],
    prompt: "双人中近景，角色被冒犯后转向对方。她没有提高音量，只是眼神直压对方，眉头轻轻下压，嘴唇变薄；停顿半秒后，用清楚、偏低的声音说出警告。愤怒轻但边界明确。",
    avoid: "避免委屈哭腔、直接大喊、手势太多。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 2,
    name: "明显愤怒/对抗",
    tags: [],
    core: "越界已成事实，角色准备改变局面。",
    eyes: "盯住目标，不轻易移开。",
    mouth: "下颌前送，咬字变硬。",
    body: "重心前压，手势变直线。",
    breath: "吸气明显，呼气重。",
    shot: "中近景，保留身体前压。",
    timeline: ["逼近半步", "重音变硬", "质问对方"],
    prompt: "中近景，角色开始正面对抗。她向前半步，肩膀定住，眼神盯住对方不放；眉头下压，下颌前送，咬字变硬，声音提高但台词清楚。她的目标是逼对方承认错误。",
    avoid: "避免每个字都吼、眼神乱飘、没有明确对象。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 3,
    name: "盛怒/爆发前沿",
    tags: [],
    core: "情绪接近失控，但仍有目标。",
    eyes: "锐利、少眨，像钉住对方。",
    mouth: "嘴唇拉紧后打开，重音重。",
    body: "可能拍桌、逼近，动作有节拍。",
    breath: "胸口起伏明显。",
    shot: "中景，给动作安全距离。",
    timeline: ["极短静止", "拍桌或逼近", "短句连续压迫"],
    prompt: "中景，角色忍到临界点。0-1秒她突然安静，直视对方；1-2秒猛地拍桌，身体前压；2-5秒用短句连续质问，声音强但关键词清楚。愤怒强烈，有目标和节拍。",
    avoid: "避免乱挥手、长时间吼叫、台词听不清。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 4,
    name: "压抑怒/冷怒",
    tags: ["restrained"],
    core: "怒很强，但爆发代价太高。",
    eyes: "冷、直、停留长，不轻易眨眼。",
    mouth: "嘴唇抿紧，微笑可变成威胁。",
    body: "身体极静，背部挺直。",
    breath: "深而慢，像把火往下压。",
    shot: "特写，重点看眼和下颌。",
    timeline: ["听完", "长时间不说话", "低声慢慢回应"],
    prompt: "特写，角色强压怒火。她听完对方的话后没有立刻回应，只是直视对方，几乎不眨眼；嘴唇抿紧，下颌锁住，呼吸深而慢；两秒后用很低、很平的声音说一句话。氛围冷、危险、克制。",
    avoid: "避免装酷空表情、完全无情绪、突然大吼。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 5,
    name: "暴怒/失控攻击",
    tags: ["peak"],
    core: "理智断裂，身体冲在语言前。",
    eyes: "发直或扫射，但保留目标。",
    mouth: "吼叫、咬牙、声音破裂。",
    body: "冲撞、摔物、推开，动作要有方向。",
    breath: "喘、喊后急吸气。",
    shot: "中景或全景，确保动作线清楚。",
    timeline: ["触发词出现", "身体冲出", "短促爆发后停顿"],
    prompt: "中景，某个触发词让角色瞬间暴怒。她先僵住半秒，然后猛地冲向桌边，抓起物件摔下，声音破裂地吼出一句短句；动作强烈但有明确目标，爆发持续很短，随后只剩急促喘息。",
    avoid: "避免真实危险动作、长时间无节制吼叫、无目标破坏。",
  },
  {
    emotion: "怒",
    type: "anger",
    level: 6,
    name: "怒后空白/虚脱",
    tags: ["peak"],
    core: "爆发耗尽，角色意识到后果。",
    eyes: "失焦、下垂或避开对方。",
    mouth: "嘴张着喘，或突然闭紧。",
    body: "后退、坐下、手无处安放。",
    breath: "乱后变慢，可能发抖。",
    shot: "静止近景或中景，留沉默。",
    timeline: ["爆发停止", "眼神失焦", "身体后退或坐下"],
    prompt: "静止中景，暴怒爆发之后突然安静。角色站在原地喘息，眼神失焦，看着自己刚刚造成的混乱；她的手悬在半空，不知道放哪里，随后慢慢后退坐下，声音变哑，几乎说不出话。",
    avoid: "避免爆发后立刻恢复正常、继续大吼、没有后果感。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 0,
    name: "失落/未承认",
    tags: ["subtle"],
    core: "损失出现，但角色还不愿承认很痛。",
    eyes: "短暂下落或看远，聚焦困难。",
    mouth: "嘴角松下，唇部少动。",
    body: "肩膀微沉，动作变慢。",
    breath: "浅，呼气变长。",
    shot: "近景配一个日常动作。",
    timeline: ["听到坏消息", "继续做原动作", "动作慢慢停住"],
    prompt: "近景，角色听到坏消息后没有立刻反应。她继续倒水，但动作变慢，眼神短暂下落，嘴角松下来；水快满了她才停住，呼气变长。情绪是失落但还没有承认。",
    avoid: "避免马上哭、夸张皱眉、动作突然过大。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 1,
    name: "轻哀/难过",
    tags: ["subtle"],
    core: "损失开始被承认，心口发沉。",
    eyes: "眼睛湿润但未必落泪，视线下垂。",
    mouth: "嘴角下落，唇轻颤或压住。",
    body: "胸口收，手臂靠近身体。",
    breath: "吸气浅，呼气带重量。",
    shot: "特写或近景。",
    timeline: ["眼神下落", "轻吸气", "用很轻的声音回应"],
    prompt: "特写，角色意识到事情已经无法挽回。她的眼神慢慢下落，眼眶变亮但没有流泪；嘴角轻轻下沉，呼吸变浅；她用很轻、尾音下坠的声音说一句“没关系”。",
    avoid: "避免哭腔过重、装可怜、强行流泪。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 2,
    name: "明确悲伤/受伤",
    tags: [],
    core: "损失明确，角色被击中。",
    eyes: "看向对方但撑不久，会掉下来。",
    mouth: "嘴唇分开或抿住，吞咽明显。",
    body: "身体缩小，抓住衣物或桌边。",
    breath: "句中断气。",
    shot: "近景，保留手部。",
    timeline: ["看向对方求证", "眼神撑不住掉下", "吞咽后说话"],
    prompt: "近景，角色终于听清真相。她抬眼看着对方，像在求证，但很快撑不住移开视线；她吞咽一下，手抓住桌边，声音变紧，句子中间断气。悲伤清楚但还没有崩溃。",
    avoid: "避免持续哭腔、只揉眼睛、脸部用力过度。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 3,
    name: "大悲/哭泣",
    tags: [],
    core: "痛苦突破防线，身体开始释放。",
    eyes: "泪水可出现，眼睛不再完全受控。",
    mouth: "嘴角下拉，嘴张开吸气。",
    body: "弯曲、靠墙、抱住自己。",
    breath: "抽气、断续、长呼。",
    shot: "近景或中近景，听见呼吸变化。",
    timeline: ["先忍住", "呼吸碎掉", "哭声从气息里出来"],
    prompt: "中近景，角色努力忍住但失败。0-1秒她咬住嘴唇，眼眶发红；1-3秒呼吸开始断，肩膀微微发抖；3-6秒她低下头，哭声从气息里出来，台词变碎但关键词仍能听清。",
    avoid: "避免一开始就大哭、台词全部糊掉、频繁揉脸。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 4,
    name: "强忍悲/体面崩边缘",
    tags: ["restrained"],
    core: "痛很重，但角色必须维持身份。",
    eyes: "眼眶亮，频繁眨眼压泪。",
    mouth: "礼貌微笑僵硬，下颌控制。",
    body: "身体挺直过度，手部固定。",
    breath: "吸气被卡住，呼气很慢。",
    shot: "特写，越克制越强。",
    timeline: ["保持礼貌", "眼泪快到边缘", "慢慢吸气压回去"],
    prompt: "特写，角色在必须体面的场合忍住悲伤。她保持礼貌微笑，但眼睛不跟着笑，眼眶发亮；下颌锁住，吸气卡住，随后很慢地呼出去；她用平稳但很薄的声音说“谢谢你来”。",
    avoid: "避免演成冷漠、直接哭出来、没有眼神裂缝。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 5,
    name: "崩溃/痛哭",
    tags: ["peak"],
    core: "防线塌掉，角色暂时无法维持功能。",
    eyes: "闭紧或失控睁大，泪水明显。",
    mouth: "哭喊、哽咽、咬字困难。",
    body: "跪坐、蜷缩、抓住支撑。",
    breath: "抽泣，喘不上气。",
    shot: "中景保证动作安全，特写拍局部也有效。",
    timeline: ["触发点出现", "身体失去支撑", "哭声冲破语言"],
    prompt: "中景，角色听到最后的坏消息。她先向后退半步，眼神空掉；随后身体失去支撑，抓住椅背慢慢滑坐下去；哭声突然冲出来，呼吸断裂，台词只剩几个碎片。崩溃有明确触发点。",
    avoid: "避免无缘由大哭、持续尖叫、动作失控无方向。",
  },
  {
    emotion: "哀",
    type: "sad",
    level: 6,
    name: "麻木/悲伤后空洞",
    tags: ["peak"],
    core: "痛苦过载后，身体切断感觉。",
    eyes: "空、少眨，像看穿眼前物。",
    mouth: "嘴唇干，微张或完全闭合。",
    body: "机械、慢、重复。",
    breath: "很浅，几乎没有起伏。",
    shot: "静止镜头，留空白时间。",
    timeline: ["哭声停止", "眼神失焦", "机械重复一个动作"],
    prompt: "静止近景，痛哭之后的角色变得麻木。她不再哭，眼神空而失焦，眨眼很少；手机械地整理桌上的物品，重复同一个动作；呼吸很浅，声音平而远。悲伤已经过载，进入空洞状态。",
    avoid: "避免完全没戏、突然恢复正常、继续表情夸张。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 0,
    name: "轻松/舒展",
    tags: ["subtle"],
    core: "危险解除，角色终于可以呼吸。",
    eyes: "视线柔和，范围变宽。",
    mouth: "嘴角自然平或微起。",
    body: "肩膀放下，动作圆润。",
    breath: "深而均匀。",
    shot: "中近景，看见肩颈放松。",
    timeline: ["紧张结束", "肩膀放下", "第一次真正呼气"],
    prompt: "中近景，紧张局面结束后，角色终于放松。她没有明显大笑，只是肩膀慢慢放下，胸口打开，长长呼出一口气；眼神从警觉变柔，嘴角自然微起。氛围轻松舒展。",
    avoid: "避免懒散、夸张笑、动作突然松垮。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 1,
    name: "愉悦/舒服",
    tags: ["subtle"],
    core: "角色享受当下，愿意停留。",
    eyes: "眼神带笑，注视不具攻击性。",
    mouth: "嘴角轻扬，脸颊柔和。",
    body: "身体自然展开，靠后或靠近。",
    breath: "顺，可能有轻笑。",
    shot: "近景，生活化。",
    timeline: ["感到舒服", "眼神变软", "轻笑或温声回应"],
    prompt: "近景，角色处在安全舒服的环境里。她的眼神变软，嘴角轻轻上扬，身体自然放松靠在椅背上；呼吸顺畅，说话声音温和，带一点轻笑。愉悦安静，不夸张。",
    avoid: "避免一直笑、过度甜腻、眼神空。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 2,
    name: "开心/玩笑感",
    tags: [],
    core: "角色被当下逗动，愿意互动。",
    eyes: "眼睛弯，视线连接同伴。",
    mouth: "笑容自然，眼角同步。",
    body: "前后轻动，手势随意。",
    breath: "笑声从呼气出来。",
    shot: "双人中近景，重在听反应。",
    timeline: ["听到笑点", "看向同伴", "笑着把话接回去"],
    prompt: "双人中近景，角色听到朋友一句玩笑。她先认真听，随后眼睛弯起来，嘴角自然上扬，呼气带出短笑；身体轻轻前倾，马上把一句调侃抛回去。开心来自互动，不是空笑。",
    avoid: "避免抢节奏、只顾自己笑、无视对方反应。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 3,
    name: "畅快/开怀",
    tags: [],
    core: "愉悦扩散到全身，气氛打开。",
    eyes: "明亮，常看向多人。",
    mouth: "开怀笑，牙齿可见。",
    body: "后仰、拍手、靠近、放开。",
    breath: "腹部笑，笑后带气。",
    shot: "中景，保留多人关系。",
    timeline: ["笑点击中", "开怀大笑", "笑后继续交流"],
    prompt: "中景，朋友说出一个荒唐但真实的笑点。角色先愣一下，然后开怀大笑，眼睛弯起，身体后仰又靠近桌边，手轻拍桌面；笑后带着气继续说话。快乐自然、有触发点、有关系。",
    avoid: "避免无理由大笑、笑太久不回到交流、动作浮夸。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 4,
    name: "忍笑/场合不允许",
    tags: ["restrained"],
    core: "觉得好笑，但身份和场合要求严肃。",
    eyes: "眼角泄露笑意，视线躲开。",
    mouth: "抿唇、咬腮，嘴角抽动。",
    body: "身体僵住或转身，肩膀微抖。",
    breath: "鼻息漏出，吸气压住笑。",
    shot: "特写或中近景，抓泄露点。",
    timeline: ["听到荒唐事", "嘴角抽动", "转头或低头压住笑"],
    prompt: "特写，角色在严肃会议里听到离谱发言。她努力保持正经，嘴唇抿住，嘴角轻轻抽动；眼睛快速躲开，鼻息漏出一点笑，肩膀微微抖；她低头看文件，试图把笑压回去。",
    avoid: "避免直接笑出声、没有压抑过程、表情过于卡通。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 5,
    name: "爆笑/失控的乐",
    tags: ["peak"],
    core: "笑越过社交控制，身体被笑牵动。",
    eyes: "眼睛眯或闭，可能笑出泪。",
    mouth: "张口大笑，说话断裂。",
    body: "前仰后合，扶桌或拍腿。",
    breath: "笑到抢气，喘。",
    shot: "中景，给身体空间。",
    timeline: ["忍不住", "笑声爆出来", "扶住桌子恢复呼吸"],
    prompt: "中景，角色终于忍不住爆笑。她先抿嘴失败，随后笑声冲出来，眼睛眯起，身体前倾扶住桌子；她想说话但被笑打断，呼吸急促，最后努力摆手表示停一下。爆笑有明确笑点。",
    avoid: "避免无缘由笑、持续过长、身体乱晃出画。",
  },
  {
    emotion: "乐",
    type: "happy",
    level: 6,
    name: "乐后满足/安静",
    tags: ["peak"],
    core: "笑够之后，关系变柔，身体松下来。",
    eyes: "湿润柔软，停留时间长。",
    mouth: "笑痕还在，嘴角慢慢落下。",
    body: "靠住椅背或靠近对方。",
    breath: "笑后的喘慢慢平。",
    shot: "近景，保留余味。",
    timeline: ["笑声下降", "呼吸慢慢平", "温柔看向对方"],
    prompt: "近景，爆笑之后房间安静下来。角色还带着笑痕，嘴角慢慢落下，呼吸从急促变平稳；她靠在椅背上，眼神柔软地看着朋友，用带笑后的低声说一句话。感觉满足、亲近、有余味。",
    avoid: "避免笑完立刻切成无关状态、继续夸张表演。",
  },
];
